import { render, staticRenderFns } from "./invitationGuest.vue?vue&type=template&id=26dcbdd2&scoped=true"
import script from "./invitationGuest.vue?vue&type=script&lang=js"
export * from "./invitationGuest.vue?vue&type=script&lang=js"
import style0 from "./invitationGuest.vue?vue&type=style&index=0&id=26dcbdd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26dcbdd2",
  null
  
)

export default component.exports